export const liveChannels = [
  {
    id: "ch1",
    name: "스포츠중계 1",
    current: "첼시 vs 아스널 (생중계)",
    next: "토트넘 vs 리버풀 (20:00)",
    category: "해외축구",
    viewers: "12,543",
  },
  {
    id: "ch2",
    name: "스포츠중계 2",
    current: "바이에른 뮌헨 vs 도르트문트 (생중계)",
    next: "인터 밀란 vs 유벤투스 (21:00)",
    category: "해외축구",
    viewers: "8,291",
  },
  {
    id: "ch3",
    name: "스포츠중계 3",
    current: "삼성 vs LG (생중계)",
    next: "보스턴 vs 뉴욕 양키스 (01:00)",
    category: "야구",
    viewers: "15,102",
  },
  {
    id: "ch4",
    name: "스포츠중계 4",
    current: "휴식 중",
    next: "울산 vs 전북 (19:30)",
    category: "국내축구",
    viewers: "-",
  },
  {
    id: "ch5",
    name: "스포츠중계 5",
    current: "휴식 중",
    next: "골든스테이트 vs LA 레이커스 (02:30)",
    category: "농구",
    viewers: "-",
  },
  {
    id: "ch6",
    name: "e스포츠중계",
    current: "T1 vs Gen.G (생중계)",
    next: "DK vs HLE (21:00)",
    category: "e스포츠",
    viewers: "22,876",
  },
  {
    id: "ch7",
    name: "스포츠중계 7",
    current: "휴식 중",
    next: "대한항공 vs 현대캐피탈 (19:00)",
    category: "배구",
    viewers: "-",
  },
  {
    id: "ch8",
    name: "스포츠중계 8",
    current: "휴식 중",
    next: "레알 마드리드 vs 바르셀로나 (22:30)",
    category: "해외축구",
    viewers: "-",
  },
];

export const broadcastSchedule = [
  { time: "14:00", channel: "스포츠중계 1", program: "프리미어리그: 첼시 vs 아스널", status: "live" },
  { time: "16:30", channel: "스포츠중계 2", program: "분데스리가: 바이에른 뮌헨 vs 도르트문트", status: "live" },
  { time: "18:00", channel: "e스포츠중계", program: "LCK: T1 vs Gen.G", status: "live" },
  { time: "19:00", channel: "스포츠중계 3", program: "KBO: 삼성 vs LG", status: "live" },
  { time: "19:30", channel: "스포츠중계 4", program: "K리그1: 울산 vs 전북", status: "upcoming" },
  { time: "20:00", channel: "스포츠중계 1", program: "프리미어리그: 토트넘 vs 리버풀", status: "upcoming" },
  { time: "21:00", channel: "스포츠중계 2", program: "세리에A: 인터 밀란 vs 유벤투스", status: "upcoming" },
  { time: "22:30", channel: "스포츠중계 8", program: "라리가: 레알 마드리드 vs 바르셀로나", status: "upcoming" },
  { time: "01:00", channel: "스포츠중계 3", program: "MLB: 보스턴 vs 뉴욕 양키스", status: "upcoming" },
  { time: "02:30", channel: "스포츠중계 5", program: "NBA: 골든스테이트 vs LA 레이커스", status: "upcoming" },
];